mutation NoteCardAccountCreate($input: NoteCardAccountCreateInput!) {
  noteCardAccountCreate(input: $input) {
    note {
      id
      noteComment
      _rowTimestamp
      isShared
      entityId
    }
  }
}